export const getPlaceCaption = (value, dataSource = []) => {
  const { title } = dataSource.find((item) => value && item.value === value) || {};

  return title;
};
